<base-section [index]="index" [section]="section">
  <div class="grid grid-section flex items-start">
    <div class="content flex-1" *ngIf="sectionRendered.introduction || sectionRendered.title">
      <h2 class="h2" [innerHTML]="sectionRendered.title"></h2>
      <div class="introduction" [innerHTML]="sectionRendered.introduction"></div>
    </div>
    <a class="button" *ngIf="sectionRendered.url" [routerLink]="[sectionRendered.url]">Tout voir</a>
  </div>
  <div class="grid grid-section overflow-auto" *ngIf="sectionRendered.display_filters && filters.length>0">
    <div class="list-pages-tags flex">
      <div class="tag tag-hoverable" (click)="onFilterClick(filter)" [ngClass]="{'tag-outline':filter.term_id !== currentFilter}" [innerHTML]="filter.name" *ngFor="let filter of filters"></div>
    </div>
  </div>
  <div class="grid grid-section md-grid-cols-5 gap-l list-pages-container mt-3">
    <tiny-post  @toggleTrigger (pageCategoriesChange)="onPageCategoriesChange($event)" class="col-1" *ngFor="let page of sectionRendered.pages|tinyPostsFromIds:orderby|async|whenPageCategorie:currentFilter" [post]="page"></tiny-post>
  </div>
</base-section>
